<div class="container-footer-mobile">
  <app-working-panel [menu]="footerMenu" [width]="'100%'"></app-working-panel>
</div>
<p class="info" [textContent]=" 'Copyright © 2021-2024 Zdorovi.UA' "></p>
